export default function (close, discrepancyResolvedState, vehicleId, discrepancy, updateDiscrepancyResolvedState, toaster) {
    const vm = this;

    /* --- */

    vm.stateEnum = discrepancyResolvedState;
    vm.selectedState = discrepancy.resolvedState;

    /* --- */

    vm.closeModal = close;
    vm.update = update;

    /* --- */

    function update(newSelectedState) {
        if (vm.selectedState.value === newSelectedState.value) {
            return;
        }
        vm.selectedState = newSelectedState;

        updateDiscrepancyResolvedState(vehicleId, discrepancy.id, newSelectedState.value)
        .then(() => {
            discrepancy.resolvedState = vm.selectedState;
            toaster.success('Discrepancy state has been successfully updated');
            close();
        })
        .catch(() => {
            toaster.error('Error while updating discrepancy state');
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/discrepancies/resolve-state/discrepancyResolveState.js